import PopoverListItem from './PopoverListItem';

export default PopoverListItem;



// WEBPACK FOOTER //
// ./~/rp-react-common/PopoverListItem/index.js